import classes from "./ActivityEditor.module.css";
import {ReactComponent as SAVED_SUCCESSFULLY} from "../../images/activity_saved_successfuly_image.svg";
import {ReactComponent as VIEW_ALL} from "../../images/activity_view_all_activities_image.svg";
import {ReactComponent as SET_UP_RELEASE} from "../../images/activity_set_up_release_image.svg";
import {useHistory, useLocation} from "react-router-dom";
import {
    ACTIVITY_TYPE_PLACEHOLDER, ATTENDANCE,
    BUTTON,
    MENU_LIST, POLL_TEXT,
    POLL_TYPE,
    SAVED_ACTIVITY_DESCRIPTION,
    SAVED_ATTENDANCE_TEXT,
    SAVED_POLL_TEXT,
    SET_UP_ACTIVITY_TO_RELEASE, SET_UP_ATTENDANCE_TO_RELEASE_DESCRIPTION, SET_UP_POLL_TO_RELEASE_DESCRIPTION,
    SET_UP_RELEASE_TEXT,
    VIEW_ALL_ACTIVITIES_DESCRIPTION,
    VIEW_ALL_ACTIVITIES_TEXT,
} from "../../utils/constants";
import React from "react";

export default function ActivityEditorSaved({pollKey, pollCode,}) {
    let history = useHistory();
    let location = useLocation();
    let pollType = location.state.pollType;

    return (
        <div
            className={`${classes.parentContainer} ${classes.straightColumnLayout}`}
            style={{alignItems: "center", gap: 20, padding: 20}}
        >
            <span style={{flex: 1}}/>
            <SAVED_SUCCESSFULLY style={{height: 120}}/>
            <span className={classes.title} style={{fontSize: 20}}>
                {pollType === POLL_TYPE.ATTENDANCE ? SAVED_ATTENDANCE_TEXT : SAVED_POLL_TEXT}
            </span>
            <span className={classes.description}>
                {SAVED_ACTIVITY_DESCRIPTION}
            </span>
            <div style={{display: "flex", marginTop: 20, gap: 30}}>
                <div
                    tabIndex={0}
                    role={BUTTON}
                    className={classes.gradeSchemaCard}
                    style={{maxWidth: 350}}
                    onClick={() => history.push(MENU_LIST.ACTIVITIES.path)}
                >
                    <VIEW_ALL style={{marginBottom: 15, flexShrink: 0}}/>
                    <span className={classes.title}>{VIEW_ALL_ACTIVITIES_TEXT}</span>
                    <span className={classes.description} style={{textAlign: "center"}}>
                        {VIEW_ALL_ACTIVITIES_DESCRIPTION}
                    </span>
                </div>

                <div
                    tabIndex={0}
                    role={BUTTON}
                    className={classes.gradeSchemaCard}
                    style={{maxWidth: 350}}
                    onClick={() => history.push(`/poll/share/${pollKey}/${pollCode}`)}
                >
                    <SET_UP_RELEASE style={{marginBottom: 15, flexShrink: 0}}/>
                    <span className={classes.title}>
                        {SET_UP_ACTIVITY_TO_RELEASE.replaceAll(
                            ACTIVITY_TYPE_PLACEHOLDER,
                            pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT
                        )}
                    </span>
                    <span className={classes.description} style={{textAlign: "center"}}>
                        {pollType === POLL_TYPE.ATTENDANCE
                            ? SET_UP_ATTENDANCE_TO_RELEASE_DESCRIPTION
                            : SET_UP_POLL_TO_RELEASE_DESCRIPTION
                        }
                    </span>
                </div>


                {/*<YuJaButton*/}
                {/*    type={"secondary"}*/}
                {/*    style={{width: 165, height: 35, display: "flex", alignItems: "center", justifyContent: "center"}}*/}
                {/*    onClick={() => history.push(MENU_LIST.ACTIVITIES.path)}*/}
                {/*>*/}
                {/*    {VIEW_ALL_ACTIVITIES_TEXT}*/}
                {/*</YuJaButton>*/}

                {/*<YuJaButton*/}
                {/*    style={{*/}
                {/*        width: 165,*/}
                {/*        height: 35,*/}
                {/*        display: "flex",*/}
                {/*        alignItems: "center",*/}
                {/*        justifyContent: "center",*/}
                {/*        whiteSpace: "nowrap"*/}
                {/*    }}*/}
                {/*    onClick={() => history.push(`/poll/share/${pollKey}/${pollCode}`)}*/}
                {/*>*/}
                {/*    {SET_UP_RELEASE_TEXT}*/}
                {/*</YuJaButton>*/}

            </div>
            <span style={{flex: 2}}/>
        </div>
    );
}